import React from "react";
import { useFormattedDate } from "../hooks/useFormatDate";

interface FormattedDateCellProps {
  value: Date | string;
  format?: string;
}

const FormattedDateCell: React.FC<FormattedDateCellProps> = ({
  value,
  format = "YYYY-MM-DD HH:mm:ss",
}) => {
  const formattedDate = useFormattedDate(value, format);
  return <span>{formattedDate}</span>;
};

export default FormattedDateCell;
